import { Component, OnInit, HostListener } from '@angular/core';

import { AlertService } from '../../../services/common/alert.service';
import { MatterTypeService } from '../../../services/matters/matter-type.service';

@Component({
  selector: 'app-matter-type-index',
  templateUrl: './matter-type-index.component.html',
  styleUrls: ['./matter-type-index.component.css'],
})
export class MatterTypeIndexComponent implements OnInit {
  matterTypes: Array<any>;

  cloneOptions: any = {
    intranets: [],
  };

  cloneFromFormSubmitting: boolean = false;
  cloneFromFormSubmitted: boolean = false;
  cloneToFormSubmitting: boolean = false;
  cloneToFormSubmitted: boolean = false;
  cloneFromMatterTypes: Array<any> = [];

  cloneFromSelection: any = {};

  cloneToSelection: any = {
    matter_type_ids: [],
  };

  constructor(private matterTypeService: MatterTypeService, private alertService: AlertService) {
    this.matterTypes = [];
    this.matterTypeService.getMatterTypes({}).then((response_json) => (this.matterTypes = response_json));
    this.matterTypeService.getCloneOptions().then((response_json) => (this.cloneOptions = response_json));
  }

  ngOnInit() {}

  @HostListener('window:scroll', ['$event'])
  window_scroll(event: any) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: any) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  selectedMatterTypeCount() {
    var count = this.cloneToSelection.matter_type_ids.length;
    if (count == 1) return '1 matter type selected';
    else return count + ' matter types selected';
  }

  intranetMatterTypeCount() {
    if (this.cloneFromSelection.intranet_id) {
      var count = this.cloneFromMatterTypes.length;
      if (count == 1) return '1 matter type found for intranet';
      else return count + ' matter types found for intranet';
    } else return 'Select an Intranet to get matter types list';
  }

  matterTypePopUp(matterType: any) {
    var resultTemplate = '';
    for (var i in matterType) {
      if (matterType.hasOwnProperty(i))
        resultTemplate += `
					<tr>
						<td>${i[0].toUpperCase()}${i.slice(1)}</td>
						<td>matterType[i]</td>
					</tr>
				`;
    }
    return `
			<table>
				${resultTemplate}
			</table>
		`;
  }

  objectKeys(object: any) {
    return Object.keys(object);
  }

  submitCloneForm(formValid: any, clone_type: any) {
    let scope: MatterTypeIndexComponent = this;
    if (clone_type == 'clone_to') {
      this.cloneToFormSubmitted = true;
      if (formValid && this.cloneToSelection.matter_type_ids.length > 0) {
        this.cloneToFormSubmitting = true;
        this.matterTypeService
          .cloneToIntranet(this.cloneToSelection)
          .then((response_json) => {
            this.cloneToFormSubmitting = false;
            if (response_json && response_json.text) {
              this.alertService.alert_status_info(response_json.text);
              this.cloneToFormSubmitted = false;
              this.cloneToSelection = {
                matter_type_ids: this.cloneToSelection.matter_type_ids,
              };
            } else this.alertService.alert_status_danger('Error in cloning');
          })
          .catch(() => {
            scope.cloneToFormSubmitting = false;
            scope.alertService.alert_status_danger('Error in cloning');
          });
      }
    } else {
      this.cloneFromFormSubmitted = true;
      if (formValid) {
        this.cloneFromFormSubmitting = true;
        this.matterTypeService
          .cloneFromIntranet(this.cloneFromSelection)
          .then((response_json) => {
            this.cloneFromFormSubmitting = false;
            if (response_json && response_json.text) {
              this.alertService.alert_status_info(response_json.text);
              this.cloneFromFormSubmitted = false;
              this.cloneFromSelection = {};
              this.matterTypeService.getMatterTypes({}).then((response_json) => (this.matterTypes = response_json));
            } else this.alertService.alert_status_danger('Error in cloning');
          })
          .catch(() => {
            scope.cloneFromFormSubmitting = false;
            scope.alertService.alert_status_danger('Error in cloning');
          });
      }
    }
  }

  deleteMatterType(matterTypeId: number) {
    let scope: MatterTypeIndexComponent = this;
    if (confirm('Are you sure?'))
      this.matterTypeService
        .deleteMatterType(matterTypeId)
        .then((response_json) => {
          if (response_json && response_json.text) {
            this.alertService.alert_status_info(response_json.text);
            this.matterTypeService.getMatterTypes({}).then((response_json) => (this.matterTypes = response_json));
          } else this.alertService.alert_status_danger('Error deleting matter type');
        })
        .catch(() => {
          scope.alertService.alert_status_danger('Error deleting matter type');
        });
  }

  onCloneFromIntranetSelect() {
    this.matterTypeService
      .getMatterTypes({
        intranet_id: this.cloneFromSelection.intranet_id,
      })
      .then((response_json) => (this.cloneFromMatterTypes = response_json));
  }

  onMatterTypeSelect(select_matter_type_id: number) {
    var selected_matter_type_ids = this.cloneToSelection.matter_type_ids;
    var index = selected_matter_type_ids.indexOf(select_matter_type_id);
    if (index > -1) selected_matter_type_ids = selected_matter_type_ids.splice(index, 1);
    else selected_matter_type_ids = selected_matter_type_ids.push(select_matter_type_id);
  }

  cloneFieldShowErrorMessage(field: any, clone_type: string | undefined = undefined) {
    var form_submitted = false;
    if (clone_type == 'clone_to') form_submitted = this.cloneToFormSubmitted;
    else form_submitted = this.cloneFromFormSubmitted;
    if (!field.valid && form_submitted) return true;
    else return false;
  }

  content_sidebar_scroll() {
    var content_main = document.getElementById('content_main');
    var content_sidebar = document.getElementById('content_sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 40;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 40;
        //console.log('lesser ' + matter_sidebar.style.top);
      }
      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  search_height_maintainer() {
    var content_sidebar = document.getElementById('content_sidebar');
    var content_search = document.getElementById('search_form');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 195;
      if (search_height > 0) content_search.style.height = search_height + 'px';
      else content_search.style.height = '0px';
    }
  }
}
